import {Component, OnInit} from '@angular/core';
import {ItemKpiService} from "../services/item-kpi.service";
import {map} from "rxjs/internal/operators";
import {FeatureSet} from "../../core/statistics-page-menu/statistics-page-menu.component";
import {environment} from "../../../environments/environment";
import {KPIS} from '../../core/kpi-modules';

@Component({
  selector: 'cintas-items-at-location',
  templateUrl: './items-at-location.component.html',
  styleUrls: ['./items-at-location.component.scss']
})
export class ItemsAtLocationComponent implements OnInit {

  itemsAtLocation$;
  // itemsAtCustomers$;
  itemsAtCleanCabinet = [
    { name: 'Sweat Jacket M', value: 90 }, // 60% of 150
    { name: 'Sweat Jacket L', value: 54 }, // 60% of 90
    { name: 'Sweat Jacket S', value: 36 }, // 60% of 60
    { name: 'Poloshirt M', value: 120 },  // 60% of 200
    { name: 'Poloshirt L', value: 72 },   // 60% of 120
    { name: 'Poloshirt S', value: 48 },   // 60% of 80
    { name: 'Sweat Pants M', value: 150 }, // 60% of 250
    { name: 'Sweat Pants L', value: 90 },  // 60% of 150
    { name: 'Sweat Pants S', value: 60 },  // 60% of 100
  ];
  
  itemsAtSoilCabinet = [
    { name: 'Sweat Jacket M', value: 37 }, // 25% of 150
    { name: 'Sweat Jacket L', value: 23 }, // 25% of 90
    { name: 'Sweat Jacket S', value: 15 }, // 25% of 60
    { name: 'Poloshirt M', value: 50 },  // 25% of 200
    { name: 'Poloshirt L', value: 30 },  // 25% of 120
    { name: 'Poloshirt S', value: 20 },  // 25% of 80
    { name: 'Sweat Pants M', value: 62 }, // 25% of 250
    { name: 'Sweat Pants L', value: 38 }, // 25% of 150
    { name: 'Sweat Pants S', value: 25 }, // 25% of 100
  ];
  
  itemsAtUsers = [
    { name: 'Sweat Jacket M', value: 23 }, // 15% of 150
    { name: 'Sweat Jacket L', value: 14 }, // 15% of 90
    { name: 'Sweat Jacket S', value: 9 },  // 15% of 60
    { name: 'Poloshirt M', value: 30 },  // 15% of 200
    { name: 'Poloshirt L', value: 18 },  // 15% of 120
    { name: 'Poloshirt S', value: 12 },  // 15% of 80
    { name: 'Sweat Pants M', value: 38 }, // 15% of 250
    { name: 'Sweat Pants L', value: 23 }, // 15% of 150
    { name: 'Sweat Pants S', value: 15 }, // 15% of 100
  ];
  
  // itemsAtSoilCabinet$;
  // itemsAtUsers$;

  noItemPerProductperUser = [
      {
        name: "John Doe",
        cuid: "cjnadbv8q0003vwt9ee1e9sud",
        series: [
          { name: "Sweat Jacket M", value: 5 },
          { name: "Sweat Jacket L", value: 3 },
          { name: "Sweat Pants M", value: 4 },
          { name: "Poloshirt M", value: 6 },
          { name: "Poloshirt L", value: 3 }
        ]
      },
      {
        name: "Jane Smith",
        cuid: "cjnadbv8q0003vwt9ee1e9sud",
        series: [
          { name: "Sweat Jacket M", value: 5 },
          { name: "Sweat Jacket L", value: 3 },
          { name: "Sweat Pants M", value: 5 },
          { name: "Poloshirt M", value: 6 },
          { name: "Poloshirt S", value: 3 }
        ]
      },
      {
        name: "Emily Johnson",
        cuid: "cjnadbv8q0003vwt9ee1e9sud",
        series: [
          { name: "Sweat Jacket M", value: 5 },
          { name: "Sweat Pants L", value: 5 },
          { name: "Poloshirt L", value: 5 },
          { name: "Poloshirt S", value: 2 },
          { name: "Sweat Pants S", value: 2 }
        ]
      },
      {
        name: "User Name 4",
        cuid: "cjnadbv8q0003vwt9ee1e9sud",
        series: [
          { name: "Sweat Jacket S", value: 3 },
          { name: "Sweat Jacket L", value: 2 },
          { name: "Sweat Pants M", value: 4 },
          { name: "Poloshirt M", value: 6 },
          { name: "Sweat Pants L", value: 3 }
        ]
      },
      {
        name: "Michael Brown",
        cuid: "cjnadbv8q0003vwt9ee1e9sud",
        series: [
          { name: "Sweat Jacket M", value: 3 },
          { name: "Poloshirt M", value: 5 },
          { name: "Poloshirt L", value: 3 },
          { name: "Sweat Pants L", value: 4 },
          { name: "Sweat Pants S", value: 4 }
        ]
      },
      {
        name: "User Name 6",
        cuid: "cjnadbv8q0003vwt9ee1e9sud",
        series: [
          { name: "Sweat Jacket S", value: 3 },
          { name: "Sweat Pants M", value: 5 },
          { name: "Poloshirt L", value: 2 },
          { name: "Poloshirt S", value: 3 },
          { name: "Sweat Pants S", value: 3 }
        ]
      }
    ];

  features: FeatureSet = {
    //export: true
  };

  chartInfoAtLocations = KPIS.itemsAtLocation.description.atLocations;
  chartInfoAtCustomers = KPIS.itemsAtLocation.description.atCustomers;
  chartInfoAtSitesPerProduct = KPIS.itemsAtLocation.description.perProduct;

  view = environment.theme.baseView;
  colorScheme = environment.theme.colorPalette;

  // options
  showLegend = true;

  // pie
  showLabels = true;
  explodeSlices = false;
  doughnut = false;

  constructor(private itemService: ItemKpiService) {
  }

  ngOnInit() {
    // this.itemsAtCleanCabinet$ = this.itemService.getItemsAtFacility(environment.cleanCabinets).pipe(map((res: any) => res.data));
    // console.log(this.itemsAtCleanCabinet$)
    // this.itemsAtSoilCabinet$ = this.itemService.getItemsAtFacility(environment.soilCabinets).pipe(map((res: any) => res.data));
    // this.itemsAtUsers$ = this.itemService.getItemsAtLocations(null, 'CabinetUser', 0).pipe(map((res: any) => res.data));
    // // this.itemsAtLocation$ = this.itemService.getItemsAtFacility(environment.facilityCuid).pipe(map((res: any) => res.data));
    // this.itemsAtCustomers$ = this.itemService.getItemsAtLocations(null, 'LaundryCustomer', 1).pipe(map((res: any) => res.data));
    // this.noItemPerProduct$ = this.itemService.getNoItemsPerCustomer().pipe(map((res: any) => res.data));
  }

  onSelect(event) {
    console.log(event);
  }

}
